<template>
    <Transition name="modal" :duration="{ enter: 1000, leave: 100 }">
        <div class="modal main-modal" :class="$store.state.app.modal.name" v-if="$store.state.app.modal.display">
            <div class="inner">
                <div class="content-modal" :class="['agency_modal', 'harkhan_modal'].includes($store.state.app.modal.name) ? 'no-align' : ''">
                    <span @click="closeModal(false)" class="close">
                        <Close :color="colorBtnClose" />
                    </span>

                    <Reference v-if="$store.state.app.modal.name == 'reference'" />
                    <Estimate v-if="$store.state.app.modal.name == 'estimate'" />
                    <Game v-if="$store.state.app.modal.name == 'game'" />
                    <GameChatGPT v-if="$store.state.app.modal.name == 'game_chat_gpt'" />
                    <HarkhanModal v-if="$store.state.app.modal.name == 'harkhan_modal'" />
                    <AgencyModal v-if="$store.state.app.modal.name == 'agency_modal'" />
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import Close from "../components/img/Close.vue";

import Reference from "../components/Reference.vue";
import Estimate from "../components/Estimate.vue";
import Game from "../components/Game.vue";
import GameChatGPT from "../components/GameChatGPT.vue";
import HarkhanModal from "../components/HarkhanModal.vue";
import AgencyModal from "../components/AgencyModal.vue";

export default {
    name: "Modal",
    data() {
        return {
            colorBtnClose: "#ff0000",
        };
    },
    components: {
        Close,
        Reference,
        Estimate,
        Game,
        GameChatGPT,
        HarkhanModal,
        AgencyModal,
    },
    watch: {
        "$store.state.app.modal.display": function (display) {
            let _this = this;
            if (display) {
                switch (this.$store.state.app.modal.name) {
                    case "harkhan_modal":
                    case "game":
                    case "reference":
                        this.colorBtnClose = "#fff";
                        break;
                    case "estimate":
                        this.colorBtnClose = "#ff0000";
                        break;
                    default:
                        this.colorBtnClose = "#000";
                        break;
                }
                document.body.classList.add("hidden");
            } else document.body.classList.remove("hidden");
        },
    },
    methods: {
        closeModal() {
            this.$store.dispatch("app/displayModal", {
                display: false,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    width: 100vw;

    .close {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 100px;
        flex: 0 0 100px;
        padding: 0 2rem;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        right: 0;

        svg {
            height: 40px;
            cursor: pointer;
        }
    }

    .inner {
        height: 800vh;
        width: 800vh;
        border-radius: 50%;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;

        .content-modal {
            height: 100%;
            width: 100vw;
            overflow-y: auto;
            opacity: 1;
            position: relative;
            box-sizing: border-box;

            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;

            display: flex;
            align-items: center;
            
            &.no-align {
                align-items: baseline;
            }
        }
    }

    &.game,
    &.reference {
        .inner {
            background-color: #000;

            .content-modal {
                background: url("@/assets/img/bg_ref_dark.png");
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }

    &.estimate {
        .inner {
            background-color: #f5f6f7;
        }
    }
}

// Animation modal
.modal-enter-active {
    transition: all 0.3s ease-in-out;

    .inner {
        transition: all 1s ease-in-out;
        transition-delay: 0.3s;

        .content-modal {
            transition: all 0.4s;
            transition-delay: 1s;
            overflow-y: hidden;
        }
    }
}

.modal-leave-active {
    transition: all 0.1s ease-in-out;
}

.modal-enter-from {
    opacity: 0;

    .inner {
        height: 0;
        width: 0;

        .content-modal {
            opacity: 0;
        }
    }
}

.modal-leave-to {
    opacity: 0;
}

@media (max-width: 1400px) {
}
@media (max-width: 1200px) {
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
    .main-modal {
        .close {
            height: 30px;
            flex: 0 0 30px;
            padding: 0 1rem;
            margin-top: 1rem;

            svg {
                height: 30px;
            }
        }
    }
}

@media (max-width: 576px) {
}
</style>
